import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, array, bool, string } from "prop-types";

import NewsWithNoImage from "../../../molecules/NewsWithNoImage";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./row2leftcolumn.m.css";

const Row2LeftColumn = ({
  stories,
  publisherAttributes,
  newsSectionArray,
  showSectionTag,
  selectedTagName = "",
  headlineSpecialColor = "",
}) => {
  const row2FirstThreeStories = stories.slice(0, 3);
  const row2SecondSixStories = stories.slice(3, 9);
  const specialNews = newsSectionArray && newsSectionArray.specialNews ? newsSectionArray.specialNews : "";
  const opinionNews = newsSectionArray && newsSectionArray.opinionNews ? newsSectionArray.opinionNews : "";
  const coronaVirusNews = newsSectionArray && newsSectionArray.coronaVirusNews ? newsSectionArray.coronaVirusNews : "";
  const businessNews = newsSectionArray && newsSectionArray.businessNews ? newsSectionArray.businessNews : "";
  const entertainmentNews =
    newsSectionArray && newsSectionArray.entertainmentNews ? newsSectionArray.entertainmentNews : "";
  const sportsNews = newsSectionArray && newsSectionArray.sportsNews ? newsSectionArray.sportsNews : "";
  return (
    <div styleName="big_box">
      <div className="big_box_row_1" styleName="big_box_row_1">
        {row2FirstThreeStories &&
          row2FirstThreeStories.map(({ story }, index) => (
            <NewsWithNoImage
              key={index}
              story={story}
              showSectionTag={showSectionTag}
              sectionData={index === 2 ? opinionNews : specialNews}
              datatrackinglabelpos={index + 3}
              selectedTagName={selectedTagName}
              headlineSpecialColor={headlineSpecialColor}
            />
          ))}
      </div>
      <div styleName="big_box_row_2">
        {row2SecondSixStories &&
          row2SecondSixStories.map(({ story }, index) => (
            <LeftImageRightNews
              key={index}
              story={story}
              showSectionTag={showSectionTag}
              sectionData={
                index === 0 || index === 1
                  ? coronaVirusNews
                  : index === 2
                  ? businessNews
                  : index === 3 || index === 4
                  ? entertainmentNews
                  : sportsNews
              }
              datatrackinglabelpos={index + 6}
              selectedTagName={selectedTagName}
              headlineSpecialColor={headlineSpecialColor}
            />
          ))}
      </div>
    </div>
  );
};

Row2LeftColumn.propTypes = {
  stories: array.isRequired,
  publisherAttributes: object,
  newsSectionArray: object,
  showSectionTag: bool,
  selectedTagName: string,
  headlineSpecialColor: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(Row2LeftColumn);
